export default () => {
  function eventMap() {
    let items = document.querySelectorAll('.placing-item');
    let visualItems = document.querySelectorAll('.placing-item__hidden');

    for (let i = 0; i < items.length; i++) {
      items[i].addEventListener('click', eventMapHandler);
      visualItems[i].addEventListener('click', eventMapHandler);

      items[i].addEventListener('mouseover', eventMapHandler);
      visualItems[i].addEventListener('mouseover', eventMapHandler);
      
      function eventMapHandler(event) {
        event.stopPropagation(); // Эта строка предотвращает всплытие события
        for (let i = 0; i < items.length; i++) {
          visualItems[i].classList.remove('active');
          items[i].classList.remove('active');
        }

        items[i].classList.add('active');
        visualItems[i].classList.add('active');
      }
    }
  }
  eventMap();

  function initZoneLabels() {
    const labels = document.querySelectorAll('.label')
    const places = document.querySelectorAll('.zone__place')

    window.addEventListener('scroll', setLabels)

    places.forEach(place => {
      place.addEventListener('mouseover', () => {
        const currentLabel = [...labels].find(label => place.dataset.place === label.dataset.location)
        currentLabel.classList.add('active')
      })

      place.addEventListener('mouseleave', () => {
        const currentLabel = [...labels].find(label => place.dataset.place === label.dataset.location)
        currentLabel.classList.remove('active')
      })
    })

    function setLabels() {
      labels.forEach(label => {
        const currentPlace = [...places].filter(place => window.getComputedStyle(place.parentElement, null).display !== 'none' && place.dataset.place === label.dataset.location)

        label.style.top = `${currentPlace[0].getBoundingClientRect().top + currentPlace[0].getBoundingClientRect().height}px`
        label.style.left = `${currentPlace[0].getBoundingClientRect().left + (currentPlace[0].getBoundingClientRect().width / 2)  - (label.clientWidth / 2)}px`

        label.addEventListener('mouseover', () => {
          // const currentPlace = [...places].filter(place => window.getComputedStyle(place.parentElement, null).display !== 'none' && place.dataset.place === label.dataset.location)
          label.classList.add('active')
          currentPlace[0].classList.add('active')
        })

        label.addEventListener('mouseleave', () => {
          label.classList.remove('active')
          currentPlace[0].classList.remove('active')
        })
      })
    }
  }
  initZoneLabels()
};